import { render, staticRenderFns } from "./EmployeeMerge.vue?vue&type=template&id=775b5b56"
import script from "./EmployeeMerge.vue?vue&type=script&lang=js"
export * from "./EmployeeMerge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports